import ApplicationRecord from "./ApplicationRecord";
import ImageRecord from "./ImageRecord";
import * as ChroniqueSections from "./ChroniqueSection";

export default class TextSection extends ApplicationRecord({
  ID: 0,
  Title: "",
  Content: "",
  _embedded: {},
}) {
  /**
   * @return {List<ImageRecord>}
   */
  images() {
    return this._getMany("Imgs", (i) => new ImageRecord(i));
  }

  cardMedia() {
    return this._getOne("CardMedia", ImageRecord);
  }

  chroniques() {
    return this._getMany(
      "ChroniqueSections",
      (chroniqueDoc) =>
        new ChroniqueSections[`ChroniqueSection${chroniqueDoc.ChroniqueType}`](
          chroniqueDoc
        )
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/TextSection.js